import Sellers from "../pages/sellers/SellersView"
import { RoutePaths } from "./RoutePaths.enum"
import Categories from "../pages/categories/CategoriesView"
import Microsites from "../pages/microSites/MicrositesView"
import Tips from "../pages/tips/TipsView"
import MicrositesFormView from "../pages/microSites/MicrositesFormView"
import SurveysFormView from "../pages/surveys/SurveysFormView"
import SurveysView from "../pages/surveys/SurveysView"
import CategoryFormView from "../pages/categories/CategoryFormView"
import SellerFormView from "../pages/sellers/SellerFormView"
import SellerServicesFormView from "../pages/sellersServices/SellerServicesFormView"
import SellerServicesView from "../pages/sellersServices/SellerServicesView"
import VouchersView from "../pages/vouchers/VoucherView"
import VoucherFormView from "../pages/vouchers/VoucherFormView"
import SignInView from "../pages/signIn/SignInView"
import Settings from "../pages/settings/SettingsView"
import { ReactComponent as BillingIcon } from "../assets/icons/billing.svg"
import Users from "../pages/users/UsersView"
import UsersFormView from "../pages/users/UsersFormView"
import UsersNotifyView from "../pages/users/UsersNotifyView"
import UsersNotifyBulkView from "../pages/users/UsersNotifyBulkView"
import TipsFormView from "../pages/tips/TipsFormView"
import TransactionsView from "../pages/transactions/TransactionsView"
import ReportsView from "../pages/reports/ReportsView"
import MarketplacesView from "../pages/marketplaces/MarketplacesView"
import { ReportService } from "../../data/services/ReportService"
import { Roles } from "../../domain/enum/roles.enum"
import ForgotView from "../pages/forgot/ForgotView"
import TransactionFormView from "../pages/transactions/TransactionFormView"
import BillingView from "../pages/billing/BillingView"
import InvoiceFormView from "../pages/billing/components/InvoiceFormView"
import B2BView from "../pages/b2b/B2BView"
import PaymentsView from "../pages/payments/PaymentsView"
import TournamentsView from "../pages/tournaments/TournamentsView"
import TournamentMembersView from "../pages/tournaments/TournamentMembersView"
import SurveySectionFormView from "../pages/surveys/SurveySectionFormView"
import ServiceReviewsView from "../pages/serviceReviews/ServiceReviewsView"
import CompanyExcelView from "../pages/companyExcel/CompanyExcelView"

const privateRoutes = [
	{
		name: "marketplaces",
		Icon: BillingIcon,
		path: RoutePaths.MARKETPLACES,
		Component: MarketplacesView,
		roles: [Roles.ADMIN]
	},
	{
		name: "reports",
		Icon: BillingIcon,
		path: RoutePaths.REPORTS,
		Component: ReportsView,
		children: ({ reportService }: { reportService: ReportService }) =>
			reportService
				.getAdminEmbeddedReport()
				.then(data =>
					data.embedUrl.map(embed => ({ id: embed.reportId, label: embed.reportName, ...data, ...embed }))
				),
		roles: [Roles.ADMIN, Roles.PARTNER, Roles.SELLER]
	},
	{
		name: "clusters",
		Icon: BillingIcon,
		path: RoutePaths.CATEGORIES,
		Component: Categories,
		roles: [Roles.ADMIN]
	},
	{
		path: RoutePaths.CATEGORIES_ADD_NEW,
		Component: CategoryFormView,
		roles: [Roles.ADMIN]
	},
	{
		name: "sellers",
		Icon: BillingIcon,
		path: RoutePaths.SELLERS,
		Component: Sellers,
		roles: [Roles.ADMIN, Roles.SELLER]
	},
	{
		path: RoutePaths.SELLERS_EDIT,
		Component: SellerFormView,
		roles: [Roles.ADMIN, Roles.SELLER]
	},
	{
		name: "services",
		Icon: BillingIcon,
		path: RoutePaths.SELLER_SERVICES,
		Component: SellerServicesView,
		roles: [Roles.ADMIN, Roles.SELLER]
	},
	{
		path: RoutePaths.SELLERS_SERVICES_NEW,
		Component: SellerServicesFormView,
		roles: [Roles.ADMIN, Roles.SELLER]
	},
	{
		path: RoutePaths.SELLERS_SERVICES_EDIT,
		Component: SellerServicesFormView,
		roles: [Roles.ADMIN, Roles.SELLER]
	},
	{
		path: RoutePaths.SERVICE_REVIEWS,
		Component: ServiceReviewsView,
		roles: [Roles.ADMIN, Roles.SELLER]
	},
	{
		name: "vouchers",
		Icon: BillingIcon,
		path: RoutePaths.VOUCHERS,
		Component: VouchersView,
		roles: [Roles.ADMIN]
	},
	{
		path: RoutePaths.VOUCHERS_ADD_NEW,
		Component: VoucherFormView,
		roles: [Roles.ADMIN]
	},
	{
		name: "microsites",
		Icon: BillingIcon,
		path: RoutePaths.MICROSITES,
		Component: Microsites,
		roles: [Roles.ADMIN]
	},
	{
		name: "users",
		Icon: BillingIcon,
		path: RoutePaths.USERS,
		Component: Users,
		roles: [Roles.ADMIN]
	},
	{
		path: RoutePaths.MICROSITES_ADD_NEW,
		Component: MicrositesFormView,
		roles: [Roles.ADMIN]
	},
	{
		name: "surveys",
		Icon: BillingIcon,
		path: RoutePaths.SURVEYS,
		Component: SurveysView,
		roles: [Roles.ADMIN]
	},
	{
		path: RoutePaths.SURVEYS_NEW,
		Component: SurveysFormView,
		roles: [Roles.ADMIN]
	},
	{
		path: RoutePaths.SURVEYS_EDIT,
		Component: SurveysFormView,
		roles: [Roles.ADMIN]
	},
	{
		path: RoutePaths.SURVEY_SECTIONS_NEW,
		Component: SurveySectionFormView,
		roles: [Roles.ADMIN]
	},
	{
		path: RoutePaths.SURVEY_SECTIONS_EDIT,
		Component: SurveySectionFormView,
		roles: [Roles.ADMIN]
	},
	{
		path: RoutePaths.SETTINGS,
		Component: Settings,
		roles: [Roles.ADMIN]
	},
	{
		name: "tips",
		Icon: BillingIcon,
		path: RoutePaths.TIPS,
		Component: Tips,
		roles: [Roles.ADMIN, Roles.SELLER]
	},
	{
		path: RoutePaths.USERS_NEW,
		Component: UsersFormView,
		roles: [Roles.ADMIN]
	},
	{
		path: RoutePaths.USERS_EDIT,
		Component: UsersFormView,
		roles: [Roles.ADMIN]
	},
	{
		path: RoutePaths.USERS_NOTIFY,
		Component: UsersNotifyView,
		roles: [Roles.ADMIN]
	},
	{
		path: RoutePaths.USERS_NOTIFY_BULK,
		Component: UsersNotifyBulkView,
		roles: [Roles.ADMIN]
	},
	{
		path: RoutePaths.TIPS_ADD_NEW,
		Component: TipsFormView,
		roles: [Roles.ADMIN, Roles.SELLER]
	},
	{
		name: "transactions",
		Icon: BillingIcon,
		path: RoutePaths.TRANSACTIONS,
		Component: TransactionsView,
		roles: [Roles.ADMIN, Roles.PARTNER, Roles.SELLER],
		index: true
	},
	{
		Icon: BillingIcon,
		path: RoutePaths.TRANSACTIONS_EDIT,
		Component: TransactionFormView,
		roles: [Roles.ADMIN]
	},
	{
		name: "billing",
		Icon: BillingIcon,
		path: RoutePaths.BILLING,
		Component: BillingView,
		roles: [Roles.ADMIN]
	},
	{
		path: RoutePaths.BILLING_TRANSACTIONS,
		Component: InvoiceFormView,
		roles: [Roles.ADMIN]
	},
	{
		name: "payments",
		Icon: BillingIcon,
		path: RoutePaths.PAYMENTS,
		Component: PaymentsView,
		roles: [Roles.ADMIN]
	},
	{
		name: "b2b",
		Icon: BillingIcon,
		path: RoutePaths.B2B,
		Component: B2BView,
		roles: [Roles.ADMIN]
	},
	{
		name: "tournaments",
		Icon: BillingIcon,
		path: RoutePaths.TOURNAMENTS,
		Component: TournamentsView,
		roles: [Roles.ADMIN]
	},
	{
		path: RoutePaths.TOURNAMENT_MEMBERS,
		Component: TournamentMembersView,
		roles: [Roles.ADMIN]
	},
	{
		name: "companyExcel",
		Icon: BillingIcon,
		path: RoutePaths.COMPANY_EXCEL,
		Component: CompanyExcelView,
		roles: [Roles.ADMIN]
	}
]

const publicRoutes = [
	{
		path: RoutePaths.SIGN_IN,
		Component: SignInView
	},
	{
		path: RoutePaths.FORGOT,
		Component: ForgotView
	}
]

const homePageRoute = RoutePaths.REPORTS

export { privateRoutes, publicRoutes, homePageRoute }
